import { i18n } from '@/locales'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    sector: 'loading',
    mainMult: 'no',
    chartComparables: [],
    priceUnderReview: false,
    events: [],
    ideas: [],
    articles: [],
    multipliers: {
      pe: [],
      evebitda: [],
      pbv: [],
    },
    dividents: [],
    previewImgUrl: false,
  },
  mutations: {
    update(state, params) {
      if (!_.isObject(params)) {
        console.log('Wrong ticker/update mutation params', params)
        return
      }
      const mapMult = (type) => (el) => ({
        name: el.name,
        value: el[type],
        description: el[`shortDesc_${i18n.locale}`] || el.shortDesc,
        general: el.general,
      })

      _.forEach(_.keys(params), (key) => {
        if (key === 'multipliers')
          state[key] = params[key].reduce(
            (acc, el) => {
              if (el.PE) acc.pe.push(mapMult('PE')(el))
              if (el.PBV) acc.pbv.push(mapMult('PBV')(el))
              if (el.EVEBITDA) acc.evebitda.push(mapMult('EVEBITDA')(el))
              return acc
            },
            { pe: [], evebitda: [], pbv: [] }
          )
        else if (key == 'events')
          state[key] = params[key].map((ev) => ({
            ...ev,
            title: ev[`title_${i18n.locale}`] || ev.title,
          }))
        else if (key == 'ideas')
          state[key] = params[key].map((idea) => ({
            ...idea,
            analystName: idea[`analystName_${i18n.locale}`] || idea.analystName,
          }))
        else state[key] = params[key]
      })
    },
  },
  actions: {
    updateConstants({ dispatch }) {
      dispatch('request/getMarkets', {}, { root: true }).then((res) => {
        console.log(res)
      })
    },
  },
  getters: {},
}
